import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
import VBodyScrollLock from 'v-body-scroll-lock'
import App from './App.vue'
import store from './store'
// eslint-disable-next-line no-unused-vars
// import MockData from './mock'

Vue.use(AsyncComputed)
Vue.use(VBodyScrollLock)
Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#accepting-orders-form')
